import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const CTASection = () => {
  return (
    <section className="bg-gradient-to-br from-brand-primary via-primary to-brand-primary py-16 lg:py-24 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-accent rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-white space-y-8">
          <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
            <Icon name="SparklesIcon" size={20} variant="solid" className="text-accent" />
            <span className="text-sm font-medium">Start Your Journey Today</span>
          </div>

          <h2 className="font-headline text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight max-w-3xl mx-auto">
            Ready to Transform Your Career with Expert-Led Learning?
          </h2>

          <p className="text-lg sm:text-xl text-white/90 max-w-2xl mx-auto leading-relaxed">
            Join 50,000+ professionals who are advancing their careers through live, interactive courses taught by industry experts.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-4">
            <Link
              href="/course-catalog"
              className="inline-flex items-center justify-center space-x-2 bg-brand-conversion hover:bg-opacity-90 text-white font-cta font-semibold px-8 py-4 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              <span>Browse All Courses</span>
              <Icon name="ArrowRightIcon" size={20} variant="solid" />
            </Link>

            <Link
              href="/student-dashboard"
              className="inline-flex items-center justify-center space-x-2 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white font-cta font-semibold px-8 py-4 rounded-lg border-2 border-white/30 transition-all duration-300"
            >
              <Icon name="AcademicCapIcon" size={20} variant="solid" />
              <span>Start Free Trial</span>
            </Link>
          </div>

          <div className="grid sm:grid-cols-3 gap-8 pt-12 max-w-3xl mx-auto">
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-white/10 backdrop-blur-sm rounded-full mb-3">
                <Icon name="CheckCircleIcon" size={24} variant="solid" className="text-accent" />
              </div>
              <p className="text-sm font-medium">No Credit Card Required</p>
            </div>
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-white/10 backdrop-blur-sm rounded-full mb-3">
                <Icon name="ClockIcon" size={24} variant="solid" className="text-accent" />
              </div>
              <p className="text-sm font-medium">Flexible Schedule</p>
            </div>
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-white/10 backdrop-blur-sm rounded-full mb-3">
                <Icon name="ShieldCheckIcon" size={24} variant="solid" className="text-accent" />
              </div>
              <p className="text-sm font-medium">Money-Back Guarantee</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;